import { FormFieldType } from "@models/form";
import { DEFAULT_LANGUAGE, Language } from "@models/language";
import {
  FieldErrors,
  FieldValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import DynamicFormCheckbox from "./DynamicFormCheckbox";
import DynamicFormInput from "./DynamicFormInput";
import DynamicFormInputNumber from "./DynamicFormInputNumber";
import DynamicFormRadio from "./DynamicFormRadio";
import DynamicFormSelect from "./DynamicFormSelect";
import DynamicFormUpload from "./DynamicFormUpload";
import { Field } from "./types";

const DynamicFormField = ({
  field,
  errors,
  register,
  setValue,
  isDirty: isDirty = true,
  language: language = DEFAULT_LANGUAGE,
  className: className = "",
}: {
  field: Field;
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  language?: Language;
  isDirty?: boolean;
  className?: string;
  setValue?: UseFormSetValue<FieldValues>;
}) => {
  switch (field.type) {
    case FormFieldType.RADIO:
      return (
        <DynamicFormRadio
          field={field}
          errors={errors}
          register={register}
          language={language}
          isDirty={isDirty}
          className={className}
        />
      );
    case FormFieldType.CHECKBOX:
      return (
        <DynamicFormCheckbox
          field={field}
          errors={errors}
          register={register}
          language={language}
          isDirty={isDirty}
          className={className}
        />
      );
    case FormFieldType.SELECT:
      return (
        <DynamicFormSelect
          field={field}
          errors={errors}
          register={register}
          language={language}
          isDirty={isDirty}
          className={className}
        />
      );
    case FormFieldType.NUMBER:
      return (
        <DynamicFormInputNumber
          field={field}
          errors={errors}
          register={register}
          language={language}
          isDirty={isDirty}
          className={className}
          setValue={setValue}
        />
      );
    case FormFieldType.FILE:
      return (
        <DynamicFormUpload
          field={field}
          errors={errors}
          register={register}
          language={language}
          isDirty={isDirty}
          className={className}
        />
      );
    default: {
      return (
        <DynamicFormInput
          field={field}
          errors={errors}
          register={register}
          language={language}
          isDirty={isDirty}
          className={className}
          setValue={setValue}
        />
      );
    }
  }
};

export default DynamicFormField;
